import { EditIcon, Trash2Icon } from 'lucide-react';
import { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '../shadcn/ui/table';
import { useSellers } from '@/hook/useSellers';
import { useEffect, useState } from 'react';
import DeleteDialog from './deleteDialog';
import React from 'react';
import { useSellersContext } from '@/context/SellerContext';
import { Seller } from '@/entities/seller';

  type TableViewProps = {
    onSellerDelete: (index:number,data:any) => void;
    data: Seller[];
  }

// eslint-disable-next-line
const SellersTableView:React.FC<TableViewProps> = ({onSellerDelete, data}) => {
  const {seller} = useSellers();
  const { open, setOpen, isEdit, setEdit, setIndexEdit, setData2Edit, data2Edit} = useSellersContext();
  const aplicarMascara = (numero:string) =>{
    // Remove todos os caracteres que não são dígitos
    const numLimpo = numero.replace(/\D/g, '');

    // Aplica a máscara
    return numLimpo.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  };
  
  return (
    <div className="m-4 rounded-md sm:border">
    <Table>
      <TableHeader>
        <TableRow className= 'mx-2 bg-indigo-50'>
          <TableHead className="w-[100px]">Nome</TableHead>
          <TableHead>Telefone</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Comissão</TableHead>
          <TableHead>Ações</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {/* eslint-disable-next-line */}
        {data.map((i, index) => (
          <TableRow className= 'mx-2' key={index}>
            <TableCell className="font-medium">{i.name}</TableCell>
            <TableCell>{aplicarMascara(i.phone)}</TableCell>
            <TableCell>{i.email}</TableCell>
            <TableCell>{i.commission.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}%</TableCell>
            <TableCell>
              <div className='flex gap-2'>
                <DeleteDialog handleDelete={() => {onSellerDelete(index, data[index]);}}/>
                <button title='Editar'>
                  <EditIcon onClick={()=>{
                    setOpen(!open);
                    setEdit(true);
                    setIndexEdit(index);
                    setData2Edit(data[index]);

                  }} size={26} className='bg-green-600 hover:bg-green-800 rounded-md p-1 -mt-1'/>
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </div>
  );
};

export default SellersTableView;
